import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBasename } from "@/api/http-client";
import { csrf_token } from "@/api/http-client";

export const groupApi = createApi({
    reducerPath: "groupApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBasename,
        prepareHeaders: (headers) => {
            headers.set("Content-Type", "application/json");
            headers.set("Accept", "application/json");
            headers.set("X-CSRF-TOKEN", csrf_token);
            return headers;
        },
    }),
    tagTypes: ["Group/Search"],
    endpoints: (build) => ({
        searchGroup: build.query({
            query: ({ ...params }) => ({
                url: "api/v1/groups/search",
                params: params,
            }),
            providesTags: ["Group/Search"],
        }),
    }),
});

export const { useSearchGroupQuery } = groupApi;
